import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import BarbaApp from './barba/BarbaApp';
import './components/menu';
import './components/VideoPlayer';
import './components/AutoplayVideos';
import './components/plausible';

export class NatuurversterkingNoordzee {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([NatuurversterkingNoordzee.domReady()]).then(() => this.init());
	}

	init() {
		new BarbaApp();
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new NatuurversterkingNoordzee();
